// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class RelatedItemsController {
   $scope: any
   $timeout: any
   bxRecommender: any
   relatedItems: any
   constructor($scope: any, $timeout: any, relatedItems: any, bxRecommender: any) {
      this.toggleRelatedItems = this.toggleRelatedItems.bind(this)
      this.toggleRelatedItemsOnSpace = this.toggleRelatedItemsOnSpace.bind(this)
      this.selectTab = this.selectTab.bind(this)
      this.getMore = this.getMore.bind(this)
      this.close = this.close.bind(this)
      this.focusResult = this.focusResult.bind(this)
      this.$scope = $scope
      this.$timeout = $timeout
      this.relatedItems = relatedItems
      this.bxRecommender = bxRecommender
      this.$scope.relatedItems = this.relatedItems.scope
      _.extend(this.$scope.relatedItems, {
         indicators: this.relatedItems.indicators,
         isActive: this.relatedItems.isActive,
         retry: this.relatedItems.retry,
         toggleRelatedItems: this.toggleRelatedItems,
         toggleRelatedItemsOnSpace: this.toggleRelatedItemsOnSpace,
         selectTab: this.selectTab,
         close: this.close,
         focusResult: this.focusResult,
         getMore: this.getMore
      }
      )
   }

   toggleRelatedItems(doc: any, event: any) {
      // set currTarget elem to triggering toggle
      this.relatedItems.currTarget =
      this.relatedItems.isActive(doc) && this.relatedItems.currTarget ?
         null
         :
         event.currentTarget
      this.relatedItems.toggleRelatedItems(doc)
      return this.bxRecommender.close()
   }

   toggleRelatedItemsOnSpace(doc: any, event: any) {
      // Space does not trigger a native click on the anchor, so handle it here.
      // Enter is handled by the global keyup handler which triggers a click.
      if (event.which === 32) {
         event.preventDefault()
         return this.toggleRelatedItems(doc, event)
      }
   }

   selectTab(type: any) {
      this.relatedItems.resetFocus = true
      return this.relatedItems.selectType(type)
   }

   getMore() {
      this.relatedItems.resetFocus = false
      return this.relatedItems.getMore()
   }

   close() {
      this.relatedItems.reset()
      // set focus back to the triggering toggle
      if (this.relatedItems.currTarget) {
         return this.$timeout(() => {
            this.relatedItems.currTarget.focus()
            return this.relatedItems.currTarget = null
         })
      }
   }

   focusResult(currentIndex: any) {
      let itemCount
      const relatedItemsLength = this.$scope.relatedItems[this.$scope.relatedItems.type].docs.length
      const focusIndex = this.relatedItems.resetFocus || (relatedItemsLength < this.relatedItems.pageSize) ?
         0
         : (itemCount = relatedItemsLength % this.relatedItems.pageSize) > 0 ?
            relatedItemsLength - itemCount
            :
            relatedItemsLength - this.relatedItems.pageSize
      return currentIndex === focusIndex
   }
}

RelatedItemsController.$inject = ['$scope', '$timeout', 'relatedItemsService', 'bxRecommenderService']

angular.module('summonApp.controllers')
   .controller('RelatedItemsCtrl', RelatedItemsController)
